<template>
  <DModal @close="$emit('close')" :isBgOverlay="true"
          :show-close="false">
    <div class="do-modal" slot="insertComponent">
      <div class="do-modal__header">
        <h2>Deaktiver puljer</h2>
        <div class="icon__bg-circle ww-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="do-modal__body">
        <div class="d-explainer-box text-explainer text-explainer__error">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-help">
            <path class="primary" d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/>
            <path class="secondary"
                  d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"/>
          </svg>
          Deaktiver puljer for Undervisning, Øvrige opgaver m.m., så systemet i stedet beregner en samlet pulje baseret på det samlede antal timer allokeret på brikker.
        </div>
        <div class="d-label-and-toggle" @click.stop="setIsActive">
          <label class="d-label color-dark">Deaktiver puljer</label>
          <div class="do-switch" :class="{'do-switch--active': isActive}"></div>
        </div>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import eventbus from '../../eventbus'

export default {
  components: {DModal},
  props: {
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: false,
      isSaving: false,
      theSettingProp: 'deactivatePools'
    }
  },
  watch: {
    isPoolsDeactivated (val, oldVal) {
      this.$emit('reReadNumbers')
      eventbus.toast = {text: 'Gemt for skolen', 'success': true}
    }
  },
  methods: {
    setIsActive () {
      this.isActive = !this.isActive
      setTimeout(_ => {
        this.onSave()
      }, 250)
    },
    onSave () {
      this.isSaving = true
      if (!this.isActive) {
        this.$store.dispatch('deleteSchoolSetting', this.theSettingProp)
      } else {
        this.$store.dispatch('updateSchoolSettings', {'deactivatePools': true})
      }
    }
  },
  mounted () {
    if (this.isPoolsDeactivated) {
      this.isActive = true
    }
  }
}
</script>

<style scoped>

.do-modal__body {
  background: #edf0f5;
  max-height: calc(100vh - 105px);
  overflow-y: auto;
  overscroll-behavior: contain;
  min-width: 500px;
  padding: 1rem;
}

.d-label-and-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  padding: 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 2rem;
}

.d-label-and-toggle label {
  cursor: pointer;
}

.d-label-and-toggle:hover {
  background: aliceblue;
}

.prep-factor-input {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.prep-factor-input > input {
  width: 80px;
  text-align: center;
  background: #fff;
}

.color-dark {
  color: #222 !important;
}

.d-explainer-box {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 480px;
}

.d-explainer-box .tw-icon {
  min-width: 24px;
}

</style>



// WEBPACK FOOTER //
// AssignHoursDeactivatePoolsModal.vue?657e5536